<template lang="pug">
div
  .arvore-item(
    :class="{ 'arvore-item-pai': isGrupo, 'arvore-selecionado': isSelected }",
    :style="{ paddingLeft: nivel * 16 + 'px' }",
    @click.stop="onSelect"
  )
    //- Ícone de expansão (grupos)
    v-icon.arvore-expand(
      v-if="isGrupo",
      x-small,
      @click.stop="$emit('toggle-expand', item)"
    ) {{ item.expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}
    span.arvore-expand-placeholder(v-else)

    //- Label
    span.arvore-label(:class="{ 'arvore-label-pai': isGrupo }") {{ item.label }}

    //- Badge de status (itens folha)
    .arvore-badge(v-if="!isGrupo", :class="statusClass") {{ statusLabel }}

  //- Filhos (recursivo)
  .arvore-children(v-if="isGrupo && item.expanded")
    arvore-item(
      v-for="child in item.children",
      :key="child.id",
      :item="child",
      :nivel="nivel + 1",
      :empresas-selecionadas="empresasSelecionadas",
      :menu-selecionado-id="menuSelecionadoId",
      @select="$emit('select', $event)",
      @toggle-expand="$emit('toggle-expand', $event)"
    )
</template>

<script>
export default {
  name: "ArvoreMenuItem",
  props: {
    item: { type: Object, required: true },
    nivel: { type: Number, default: 0 },
    empresasSelecionadas: { type: Array, default: () => [] },
    menuSelecionadoId: { type: String, default: null },
  },
  computed: {
    isGrupo() {
      return this.item.children && this.item.children.length > 0;
    },
    isSelected() {
      return this.menuSelecionadoId === this.item.id;
    },
    permissoesCount() {
      if (!this.item.permissoes) return null;
      const total = this.empresasSelecionadas.length;
      if (total === 0) return { permitidas: 0, total: 0 };
      const permitidas = this.empresasSelecionadas.filter((e) => {
        const val = this.item.permissoes[e.cnpj];
        return val !== false;
      }).length;
      return { permitidas, total };
    },
    status() {
      const counts = this.permissoesCount;
      if (!counts || counts.total === 0) return "nenhuma";
      if (counts.permitidas === counts.total) return "todas";
      if (counts.permitidas === 0) return "nenhuma";
      return "algumas";
    },
    statusClass() {
      return {
        "arvore-badge-todas": this.status === "todas",
        "arvore-badge-algumas": this.status === "algumas",
        "arvore-badge-nenhuma": this.status === "nenhuma",
      };
    },
    statusLabel() {
      if (!this.permissoesCount) return "-/0";
      const { permitidas, total } = this.permissoesCount;
      return `${permitidas}/${total}`;
    },
  },
  methods: {
    onSelect() {
      if (!this.isGrupo) {
        this.$emit("select", this.item);
      }
    },
  },
};
</script>
